import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import contracts from './contracts'
import dailys from './dailys'
import auth from './auth'

const store = new Vuex.Store({    
    modules: {
        auth,
        contracts,
        dailys
    },
})

export default store